<template>
  <v-main>
    <v-overlay v-if="closed === null">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container>
      <v-row v-if="closed">
        <v-col cols="12" sm="8" md="6" lg="4" v-html="closedMessage"> </v-col>
      </v-row>
      <v-row v-else>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-text-field
            v-if="!validate"
            v-model="email"
            type="email"
            class="ma-0 mt-16"
            width="400"
            rounded
            outlined
            append-icon="mdi-send"
            :rules="[rules.required, rules.email]"
            @click:append="testEmail"
            placeholder="Introduce tu correo electrónico"
          ></v-text-field>
          <v-card-text v-if="!validate" class="ma-0">
            Necesitamos tu correo electrónico para asegurarnos de que hay
            alumnos del Liceo Sorolla C a tu cargo. Si la dirección es correcta
            te enviaremos un correo para que puedas acceder a la gestión.
          </v-card-text>
          <v-card-text v-else class="ma-0">
            Te hemos enviado un correo a
            <span class="email">{{ email }}</span> con detalles para continuar
            con el trámite.
          </v-card-text>
          <v-card-text v-if="error && !validate" class="ma-0">
            No hemos encontrado ningún alumno a tu cargo en nuestra base de
            datos. Puede que no tengamos tu dirección de correo electrónico,
            ponte en contacto con el colegio para realizar la gestión.
          </v-card-text>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
/* eslint-disable no-console*/
import { newId, students, tokens, properties } from "../firebaseConfig.js";

export default {
  data() {
    return {
      closed: null,
      closedMessage: "",
      email: "",
      validate: null,
      error: false,
      rules: {
        required: (v) => !!v || "Obligatorio",
        email: (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "No es una dirección de correo",
      },
    };
  },
  created() {
    properties
      .doc("closemessage")
      .get()
      .then((closeRef) => {
        if (closeRef.exists) {
          this.closed = closeRef.data().active;
          this.closedMessage = closeRef.data().message;
        }
      });
  },
  methods: {
    testEmail() {
      students
        .where("fatherEmail", "==", this.email)
        .get()
        .then((studentsRef) => {
          if (studentsRef.size > 0) {
            this.validate = true;
            console.log(this.validate);
            let id = newId();
            tokens.doc(id).set({
              id,
              created: new Date(),
              gender: "male",
              email: this.email,
            });
          } else {
            students
              .where("motherEmail", "==", this.email)
              .get()
              .then((studentsRef) => {
                if (studentsRef.size > 0) {
                  this.validate = true;
                  console.log(this.validate);
                  let id = newId();
                  tokens.doc(id).set({
                    id,
                    created: new Date(),
                    gender: "female",
                    email: this.email,
                  });
                } else {
                  this.error = true;
                  this.validate = false;
                  console.log(this.validate);
                  console.log("Ningún alumno a tu cargo en el centro.");
                }
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.email {
  color: gray;
  border-bottom: 1px solid gray;
}
</style>
